import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { ProjectTechnology, TechnologyCollection, TopcoProjectTechnology } from '@/features/projects/types';
import { TopcoFormNew, TopcoSubmitFields } from './topco-form-new';

export type TopcoDrawerProps = {
  readonly formId: string;
  readonly technology: ProjectTechnology;
  readonly isOpen: boolean;
  readonly onSubmit: (collection: TechnologyCollection, item: TopcoProjectTechnology, description?: string) => void;
  readonly onClose: () => void;
};

export function TopcoDrawer({ formId, technology, isOpen, onSubmit, onClose }: TopcoDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('TopCo Details & Design')} open={isOpen} onClose={onClose} footer={footer}>
      <TopcoFormNew
        id={formId}
        item={technology?.item as TopcoProjectTechnology}
        onSubmit={(data: TopcoSubmitFields) =>
          onSubmit(
            'projects_topco_technologies',
            { ...(technology?.item as TopcoProjectTechnology), ...data },
            t('TopCo Details has been updated')
          )
        }
      />
    </Drawer>
  );
}
